/* eslint-disable no-unsafe-optional-chaining */
import { useState, useMemo, useContext } from "react"
import { useMediaQuery } from "@utils"
import { DogsLandingsContext } from "@context/dogsLandingsContext"

export const useGetSeoList = (list, type) => {
  const { variables } = useContext(DogsLandingsContext)

  const [showAll, setShowAll] = useState(false)
  const isMobile = useMediaQuery("(max-width:600px)")

  const hasNoLinks = Boolean(list?.withDogs?.length === 0)

  const linkList = useMemo(() => {
    const dogs = showAll
      ? [...list?.withDogs, ...list?.withoutDogs]
      : list?.withDogs

    return dogs?.map((item) => {
      const shortName =
        item.name?.length > 20 ? item.name?.slice(0, 20) + "..." : item.name
      const linkText = isMobile
        ? shortName
        : `${item.name} ${type === "byBreed" && item.count > 1 ? `(${item.count} puppies)` : type === "byBreed" && item.count === 1 ? `(${item.count} puppy)` : ""}`
      const path =
        type === "byBreed"
          ? `${item.slug}/${variables?.stateSlug || variables?.slug}`
          : `${variables?.slug}/${item.slug}`
      return { ...item, link: `/puppies-for-sale/${path}`, linkText }
    })
  }, [list, showAll, variables, isMobile, type])

  return {
    showAll,
    setShowAll,
    linkList,
    hasNoLinks,
  }
}
